import request from '@/utils/request'

// 获取服务列表
export const getServiceData = (params) => request({
  url: '/workOnLine/employ/open/homepage/employList',
  method: 'get',
  params
})
// 获取用户数据
export const getUserData = () => request({
  url: '/workOnLine/employ/user/homepage/data',
  method: 'get'
})